import { Component, OnInit, ViewEncapsulation  } from '@angular/core';
import { Inject, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { Router } from '@angular/router';
// Modelos
import { VisitaList } from '../../models/visita-list';
// Servicios
import { VisitasService } from '../../services/visitas.service';

@Component({
  selector: 'app-visitas',
  templateUrl: './visitas.component.html',
  styleUrls: ['./visitas.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class VisitasComponent implements OnInit
{
  public displayedColumns: string[];
  public visitas: MatTableDataSource<VisitaList>;

  // Campos de filtrado
  defaultPageIndex;
  defaultPageSize;
  public defaultSortColumn;
  public defaultSortOrder;
  defaultFilterColumn;
  filterQuery: string;
  pageEvent: PageEvent;

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;

  // Los eleemntos declarados por el constructor de esta forma estan declarados en toda la clase
  constructor(private visitasService: VisitasService, private router: Router)
  {
    console.log("constructor");
    this.displayedColumns = ['codigoTasacion', 'localidad', 'direccion'];
    this.defaultPageIndex = 0;
    this.defaultPageSize = 10;
    this.defaultSortColumn = 'fechaVisita';
    this.defaultSortOrder = 'desc';
    this.defaultFilterColumn = 'fechaVisita';
    this.filterQuery = null;
  }

  ngOnInit()
  {
    console.log("ngOnInit");
    this.loadData();
  }

  loadData(query: string = null)
  {
    console.log("loadData");
    this.pageEvent = new PageEvent();
    this.pageEvent.pageIndex = this.defaultPageIndex;
    this.pageEvent.pageSize = this.defaultPageSize;
    if (query)
      this.filterQuery = query;
    this.getData(this.pageEvent);
  }

  getData(event: PageEvent) : PageEvent
  {
    console.log("getData");
    let sortColumn;
    let sortOrder;
    let filterColumn;
    let filterQuery;

    sortColumn = (this.sort) ? this.sort.active: this.defaultSortColumn;
    sortOrder = (this.sort) ? this.sort.direction : this.defaultSortOrder;
    filterColumn = (this.filterQuery) ? this.defaultFilterColumn : null;
    filterQuery = (this.filterQuery) ? this.filterQuery: null;
    this.visitasService.getData(
      event.pageIndex,
      event.pageSize,
      sortColumn,
      sortOrder,
      filterColumn,
      filterQuery)
      .subscribe(result => {
        console.log("totalCount: "+result.totalCount);
        console.log(this.paginator);        
        this.paginator.length = result.totalCount;
        this.paginator.pageIndex = result.pageIndex;
        this.paginator.pageSize = result.pageSize;
        this.visitas = new MatTableDataSource<VisitaList>(result.data);
      }, error => console.error(error));
      return event;
  }

  clickRow(id: number, version: number)
  {
    this.router.navigate([`/visita/${id}/${version}`]);
  }
}
